export const campaignIdsWithExpirationDate: number[] = [
  655708, 656719, 656745, 656781, 658893, 658895, 657838, 656826, 656634
];
